import { encodeId } from "~/helpers";
import { MapProduct } from "~/modules/catalog/category/composables/useElasticSearch/types";

const mapCategories = (categories: any[] = []) => {
  return categories.map((cat: any) => ({
    id: cat.category_id,
    uid: encodeId(cat.category_id),
    name: cat.name,
    __typename: "CategoryTree",
  }));
};

const mapConfigurableOptions = (options: any[] = []) => {
  return options.map((option: any) => ({
    attribute_id: option.attribute_id,
    attribute_code: option.attribute_code,
    label: option.label,
    values: mapOptionValues(option.values),
    uid: encodeId(option.attribute_id),
  }));
};

const mapOptionValues = (values: any[] = []) => {
  return values.map((value: any) => ({
    label: value.label,
    value_index: value.value_index,
    uid: encodeId(value.value_index),
    swatch_data: mapSwatchData(value.swatch),
    swatch: value.swatch_data,
  }));
};

const mapSwatchData = (swatch: any = {}) => {
  return {
    value: swatch?.value || "",
    thumbnail: swatch?.swatch_link || "",
    type: swatch?.type || "",
    __typename: "ImageSwatchData",
  };
};

const mapVariants = (variants: any[] = []) => {
  return variants.map((variant: any) => ({
    id: variant.id,
    uid: encodeId(variant.id),
    sku: variant.sku,
    name: variant.name,
    mastercolor: variant.mastercolor,
    size: variant.size,
    color: variant.color,
    is_pre_order: variant.is_pre_order,
    media_gallery: variant.media_gallery,
    final_price: variant.final_price || variant.regular_price,
    regular_price: variant.regular_price,
    image: variant.image,
    small_image: variant.small_image,
    thumbnail: variant.thumbnail,
    swatch_thumbnail: variant.swatch_thumbnail,
  }));
};

export const mapProduct = (product: any): MapProduct | null => {
  if (!product) return null;

  return {
    id: product?.id,
    uid_map: encodeId(product?.id),
    type_id: product?.type_id,
    sku: product?.sku,
    name: product?.name,
    first_child_product: product?.first_child_product,
    url_path: product?.url_path,
    url_key: product?.url_key,
    labels_sales: product?.labels_sales || null,
    flash_sale: product?.flash_sale || null,
    promotion_image_detail: product?.promotion_image_detail,
    promotion_image_list: product?.promotion_image_list,
    product_note: product?.product_note || null,
    campaign: product?.campaign || null,
    sizeguide: product?.sizeguide,
    related_category_id: product?.related_category_id || null,
    related_products: product?.related_products || [],
    instruction: product?.instruction,
    materials: product?.materials,
    is_pre_order: product?.is_pre_order,
    description_map: product?.description,
    short_description_map: product?.short_description,
    final_price: product?.final_price,
    regular_price: product?.regular_price,
    media_gallery: product?.media_gallery,
    thumbnail_url: product?.thumbnail,
    image_map: product?.image,
    configurable_children: mapVariants(product?.configurable_children),
    configurable_options_map: mapConfigurableOptions(product?.configurable_options),
    categories_map: mapCategories(product?.category),
    saleQty: product?.saleQty || 0,
    fake_qty: product?.fake_qty || 0,
    deals: product?.deals || null,
    deal_qty: product?.deal_qty || 0,
    deal_price: product?.deal_price || 0,
    promotion_url_path: product?.promotion_url_path || null,
    // the meta
    meta_description: product?.meta_description || product?.description || null,
    meta_title: product?.meta_title || null,
    title: product?.title || product?.meta_title || product?.name || null,
    meta_keyword: product?.meta_keyword || product?.meta_keywords || null,
    simi_category_thumbnail: product?.simi_category_thumbnail || null,
    category_ids: product?.category_ids || [],
  };
};
